/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { FormattedMessage } from 'react-intl';

import MedliTerm from '../components/MedliTerm';

import createDescription from '../../models/HealthEntryCompose/description';
import { useActiveUser } from '../hooks/useUser';
import { useAmountUnit } from '../hooks/useMedli';

const TextPair = (props) => {
  const { pair, languageCode } = props;

  return pair.value ? (
    <span> {pair.value} <MedliTerm medliTerm={pair.unit} languageCode={languageCode} /></span>
  ) : null;
};

interface Props {
  languageCode?: string;
  amount: any;
  displayNAUnit?: boolean;
  description?: any;
  className?: string;
  style?: any;
}
const MedliAmountText: React.FC<Props> = (props) => {
  const { displayNAUnit, description, className, style } = props;

  const [{ isNA, unitPairs, value }] = useAmountUnit(props.amount, true);
  const [{ preferredLanguageCode }] = useActiveUser();
  const languageCode = props.languageCode || preferredLanguageCode;

  let pair1 = null;
  let pair2 = null;
  if (!displayNAUnit && isNA) {
    pair1 = value;
  } else {
    const valuePairs = unitPairs.filter(v => v.value);

    if (valuePairs.length === 1) {
      pair1 = <TextPair pair={valuePairs[0]} languageCode={languageCode} />;
    } else if (valuePairs.length === 2) {
      pair1 = <TextPair pair={valuePairs[0]} languageCode={languageCode} />;
      pair2 = <TextPair pair={valuePairs[1]} languageCode={languageCode} />;
    }
  }

  let descText = null;
  const descriptionInstance = createDescription({ description }, languageCode);

  if (descriptionInstance.hasDescription()) {
    descText = (pair1 || pair2) ? `, ${descriptionInstance.formattedTermName()}` : descriptionInstance.formattedTermName();
  } else if (!pair1) {
    pair1 = <FormattedMessage id="ui-data.value.not-specified.text" />;
  }

  return (
    <span className={className} style={style}>
      {pair1}{pair2}{descText}
    </span>
  );
};

export default MedliAmountText;
